import { z } from "zod";

import { zIsoDate, zNonEmptyString, zPhoneNumber } from "../../util";

export const zAccountOpener = z.object({
  is_legal_account_opener: z.literal(true),
  given_name: zNonEmptyString,
  middle_name: z.string().optional(),
  family_name: zNonEmptyString,
  date_of_birth: zIsoDate.refine(
    (d) => d <= new Date().toISOString().substring(0, 10),
    "Date cannot be in the future",
  ),
  country_of_citizenship: zNonEmptyString,
  is_control_person: z.boolean(),
  controlling_firms: z.string().optional(),
  is_affiliated_exchange_or_finra: z.boolean(),
  affiliated_firm: z.string().optional(),
  title_at_company: zNonEmptyString,
  phone_number: zPhoneNumber,
  tax_id_type: zNonEmptyString,
  tax_id: z.string().optional(),
  country_of_tax_residence: zNonEmptyString,
  street_address: zNonEmptyString,
  city: zNonEmptyString,
  state: zNonEmptyString,
  postal_code: zNonEmptyString,
  unit: z.string().optional(),
  is_politically_exposed: z.boolean(),
  immediate_family_exposed: z.boolean(),
  email: z.string().email().optional(),
});

export type AccountOpener = z.infer<typeof zAccountOpener>;
